if (typeof window.FfModal === "undefined") {
  class FfModal {
    static instance;

    constructor() {
      if (FfModal.instance) return FfModal.instance;

      this.createModal();
      FfModal.instance = this;
    }

    createModal() {
      this.ffModal = document.createElement("div");
      this.ffModal.className = "ff-fullscreen-modal";
      this.ffModal.innerHTML = `
        <div class="ff-modal-content">
          <div class="ff-modal-title">
            <p class="ff-mv-0 ff-font-16 ff-font-w-300 ff-font-12-mb ff-color-grey-10">Select size</p>
            <button class="ff-modal-close ff-button">
              <svg width="10" focusable="false" viewBox="0 0 20 19" role="presentation" fill="none" class="jsx-7936e70d091b5ab5 base"><path d="M1.00098 0.5L19.001 18.5" stroke="black"></path><path d="M19.001 0.5L1.00098 18.5" stroke="black"></path></svg>
            </button>
          </div>
          <div class="ff-modal-body">
          </div>
        </div>
      `;

      document.body.appendChild(this.ffModal);
      this.ffModal
        .querySelector(".ff-modal-close")
        .addEventListener("click", () => this.close());
      this.ffModal.addEventListener("click", () => this.close());
      this.ffModal
        .querySelector(".ff-modal-content")
        .addEventListener("click", (event) => {
          event.stopPropagation();
        });
    }

    open(content, sizeChartEl) {
      const modalBodyEl = this.ffModal.querySelector(".ff-modal-body")
      modalBodyEl.innerHTML = content;
      
      if (sizeChartEl) {
        sizeChartEl.style.display = "";
        modalBodyEl.appendChild(sizeChartEl);
      }

      this.ffModal.style.display = "flex";
    }

    close() {
      this.ffModal.style.display = "none";
    }
  }

  window.FfModal = FfModal;
}

if (!customElements.get("ff-modal-trigger")) {
  class FfModalTrigger extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.ffInitElements();
      this.ffSetConfig();
    }

    ffInitElements() {
      this.ffModal = new FfModal();
    }

    ffSetConfig() {
      this.ffVariants = JSON.parse(this.dataset.ffVariants);
      this.ffVariantsMetafields = this.ffGetVariantsMetafields();
      this.ffCardProductContainer = document.querySelector(
        "#" + this.dataset.ffCardProductId
      );
      this.sizeChartEl = this.querySelector("ff-size-chart");

      this.addEventListener("click", () => {
        const ffModalContent = this.ffGenerateModalContent();
        this.ffModal.open(ffModalContent, this.sizeChartEl);
        requestAnimationFrame(() => this.ffBindModalButtons());
      });
    }

    ffGetVariantsMetafields() {
      let ffDatasetSplited = this.dataset.ffVariantsMetafields.split(",");
      return ffDatasetSplited.map((part) => part.replace(/\$/g, "'"));
    }

    ffGenerateModalContent() {
      let content = "";

      this.ffVariants.forEach((ffVariant, ffIndex) => {
        const ffMetafield = this.ffVariantsMetafields?.[ffIndex] || "";
        const ffButtonDisabled = ffVariant.available ? "" : "disabled";

        content += `
          <button
            class="ff-variant-button ff-button ${ffButtonDisabled}"
            data-ff-variant-id="${ffVariant.id}"
            ${ffButtonDisabled}
          >
            <p class="ff-mv-0 ff-font-16 ff-font-w-300 ff-font-12-mb ff-color-black">
              ${ffVariant.title}
            </p>
            <p class="ff-mv-0 ff-font-14 ff-font-w-300 ff-font-12-mb ff-color-grey-10">
              ${ffMetafield}
            </p>
          </button>
        `;
      });

      return content;
    }

    ffBindModalButtons() {
      const ffButtons =
        this.ffModal.ffModal.querySelectorAll(".ff-variant-button");

      ffButtons.forEach((button) => {
        button.addEventListener("click", () => {
          const ffProductForm =
            this.ffCardProductContainer.querySelector(`product-form`);

          const ffSubmitButton = ffProductForm?.querySelector(
            'button[type="submit"]'
          );
          const ffInput = ffProductForm?.querySelector('input[name="id"]');

          if (ffInput) ffInput.value = button.dataset.ffVariantId;

          if (ffSubmitButton) {
            ffSubmitButton.click();
            this.ffModal.close();
          }
        });
      });
    }
  }

  customElements.define("ff-modal-trigger", FfModalTrigger);
}
